
import { Badge } from '@/components/ui/badge';
import { User } from '@/types/user';

interface UserRoleBadgeProps {
  user: User;
}

export function UserRoleBadge({ user }: UserRoleBadgeProps) {
  return (
    <Badge variant={
      user.role === 'Admin' ? 'default' :
      user.role === 'Editor' ? 'secondary' : 'outline'
    }>
      {user.role}
    </Badge>
  );
}
